<template>
  <div class="ess-element-wrap" :class="{'ess-payload': isAbsolute}">
    <div class="ess-line down"></div>
    <div class="ess-element">
      <div class="ess-element__header meter">
        <img src="./icons/ic_payload.png" width="20" alt="">
        <div class="ess-element__name">{{$str.getKey('数据可视化/负载')}}</div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { computed } from 'vue'
const $str = window.$str
const props = defineProps(['eLinks'])

const isAbsolute = computed(() => {
  // let eLinkCount = props.eLinks.length
  // let eBlockCount = 0
  // for (const eLink of props.eLinks) {
  //   eBlockCount += eLink.eBlocks.length
  // }
  // if (eLinkCount == 1) {
  //   return eBlockCount <= 10
  // }
  // if (eLinkCount <= 3) {
  //   return true
  // }
  return false
})

</script>
